import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { EmailCertifiedConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';

export class EmailCertifiedNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: EmailCertifiedConfig) {
    super(id, NodeType.SendCertifiedEmail, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['copyIds'].length == 0;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
    else return;
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else return;
  }

  initNodeConfig() {
    (this.config as EmailCertifiedConfig).copyIds = [];
    (this.config as EmailCertifiedConfig).certified = true;
    (this.config as EmailCertifiedConfig).super = false;
    (this.config as EmailCertifiedConfig).sendToAllContacts = false;
    (this.config as EmailCertifiedConfig).expirationDays = 180;
    (this.config as EmailCertifiedConfig).expirationAt = null;
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    if (this.isEmptyConfig()) {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_COPY_IDS, {
        nodoType: 'Email Certificado',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    return errors;
  }
}
